import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c17ff326&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c17ff326')) {
      api.createRecord('c17ff326', component.options)
    } else {
      api.reload('c17ff326', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=c17ff326&", function () {
      api.rerender('c17ff326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advocacy/Index.vue"
export default component.exports